var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5431",
    d: "M4.24219 0.242641H8.48483L4.24219 4.48528L-0.000453115 0.242641H4.24219Z",
    fill: "#725798"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleTriangle);
export default __webpack_public_path__ + "static/media/purple-triangle.9a7684c0e309f33f49f413404f7ff011.svg";
export { ForwardRef as ReactComponent };